import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-domino',
  templateUrl: './domino.component.html',
  styleUrls: ['./domino.component.css']
})
export class DominoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
